export { default } from './VerticalCollapsedList';
